import { faUserCircle } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaRegTrashCan } from "react-icons/fa6";
import "../BusinessImpactComment/index.css";
import "./index.css";

const BusinessImpactReply = (props) => {
  const { userName, date, commentText, id, handleDeleteReplyClick, accessActionAddReply } = props;
  return (
    <div className="reply-section-wrapper">
      <div className="comment-heading">Reply</div>
      <div className="reply-heading">
        <div className="user-name-section">
          <FontAwesomeIcon icon={faUserCircle} style={{ fontSize: "24px", color: "#4B4B55" }} />
          <div>
            <div className="comment-heading">{userName}</div>
            <div className="comment-date-heading">{date}</div>
          </div>
        </div>
        {accessActionAddReply && (
          <FaRegTrashCan color={"#4B4B55"} style={{ height: "20px", width: "17px", cursor: "pointer" }} onClick={() => handleDeleteReplyClick(id)} />
        )}
      </div>
      <div className="business-imapct-reply-text">{commentText}</div>
    </div>
  );
};

export default BusinessImpactReply;
